import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

import "./delete-template-popup.scss";

interface DeleteTemplatePopupProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
}
const DeleteTemplatePopup = ({
  open,
  onClose,
  onDelete,
}: DeleteTemplatePopupProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: "delete-dialog-paper" }}
    >
      <DialogContent className="delete-dialog-content">
        <div className="icon-wrapper">
          <WarningAmberRoundedIcon className="warning-icon" />
        </div>

        <Typography className="title">Delete Template</Typography>

        <Typography className="message">
          Are you sure you want to delete this contract template? This action cannot be undone.
        </Typography>
      </DialogContent>

      <DialogActions className="actions">
        <Button variant="outlined" className="cancel-delete-btn" onClick={onClose}>
          Cancel
        </Button>

        <Button
          variant="contained"
          color="error"
          className="delete-btn"
          onClick={onDelete}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTemplatePopup;
